<!-- 首页 -->
<template>
  <div ref="home" class="home">
    <Header></Header>
    <payPage ref="pay"></payPage>
    <!-- banner图部分 -->
    <!-- 移动端轮播图 -->
    <swiper :options="swiperOptions" v-if="bannerArr.length > 0">
      <swiper-slide v-for="(item,index) in bannerArr" :key="index">
        <div class="blockText animate__animated animate__zoomIn">
          <h4>{{ item.title }}</h4>
          <h5>
            <pre>{{ item.subtitle }}</pre>
          </h5>
          <a href="javascript:void(0);" class="comButton collection-1 btn-15">
            <span v-if="!item.id">Apply for a free trial</span>
            <span v-else @click="toInfo(item)">查看详情</span>
          </a>
        </div>
        <img ref="swiperImg" :src="item.sliderImg" alt />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- pc端轮播图 -->
    <div class="block">
      <el-carousel height="100vh" class="el-carousel_pc" arrow="always">
        <el-carousel-item v-for="(item,index) in bannerArr" :key="index">
          <h3 class="small">
            <div class="blockText animate__animated animate__zoomIn">
              <h4>{{ item.title }}</h4>
              <h5>
                <pre>{{ item.subtitle }}</pre>
              </h5>
              <a href="javascript:void(0);" class="comButton collection-1 btn-15">
                <span v-if="!item.id">Apply for a free trial</span>
                <span v-else @click="toInfo(item)">查看详情</span>
              </a>
            </div>
            <img :src="item.sliderImg" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 解决方案 -->
    <div>
      <div class="currencyTitle">
        <img src="../assets/images/logoTitle.png" alt />
        <h3>We provide comprehensive solutions</h3>
      </div>
      <solvePage></solvePage>
    </div>
    <!-- 融合零信任安全网络和自动化运维 -->
    <div style="overflow:hidden;">
      <div class="innerBox wow animate__animated animate__fadeInUp">
        <div class="currencyTitle">
          <img src="../assets/images/logoTitle.png" alt />
          <h3>Integrate zero trust security network and automated operation and maintenance</h3>
        </div>
        <robotPage></robotPage>
      </div>
    </div>
    <!-- 全球覆盖网络 -->
    <div style="overflow:hidden;">
      <div class="innerBox wow animate__animated animate__fadeInUp">
        <div class="currencyTitle">
          <img src="../assets/images/logoTitle.png" alt />
          <h3>Global coverage network</h3>
        </div>
        <worldPage></worldPage>
      </div>
    </div>
    <!-- 我们拥有高品质的服务 -->
    <div style="overflow:hidden;">
      <div class="innerBox wow animate__animated animate__fadeInUp">
        <div class="currencyTitle">
          <img src="../assets/images/logoTitle.png" alt />
          <h3>We have high-quality service</h3>
        </div>
        <servicePage></servicePage>
      </div>
    </div>
    <!-- 用一个更好的方式服务企业 -->
    <div style="overflow:hidden;">
      <div class="innerBox wow animate__animated animate__fadeInUp">
        <div class="currencyTitle">
          <img src="../assets/images/logoTitle.png" alt />
          <h3>Serving the enterprise in a better way</h3>
        </div>
        <wayPage></wayPage>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="wow animate__animated animate__fadeInUp">
      <div class="currencyTitle">
        <img :src="baseImgUrl + '/u/20230102/编组@2x_1672629041546.png'" alt />
        <h3>News and Information</h3>
      </div>
      <!-- pc端新闻资讯 -->
      <div class="styleBox_06">
        <img class="news_bg" src="../assets/images/img_news.jpg" alt />
        <ul>
          <li
            v-show="index < 3"
            v-for="(item,index) in newsArr"
            :key="index"
            @mouseenter="hoverNews(index)"
            @mouseleave="outNews()"
          >
            <img :src="item.coverImage" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.description.split('@')[0] }}</p>
            <div>
              <span>{{ item.createTime }}</span>
              <img v-if="item.charge === 0" :src="item.hover ? img_more02 : img_more01" />
              <span v-else>Payment information: 2 yuan/piece</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 移动端新闻资讯 -->
      <el-carousel class="newsBg" :interval="4000" type="card" height="22.8rem">
        <el-carousel-item v-for="(item,index) in newsArr" :key="index">
          <div
            class="newBanner"
            @mouseenter="hoverNews(index)"
            @mouseleave="outNews()"
          >
            <img class="bannerImg" :src="item.coverImage" />
            <h4>
              <span>{{ item.title }}</span>
            </h4>
            <p>{{ item.description }}</p>
            <div class="newFooter">
              <span>{{ item.createTime }}</span>
              <img v-if="item.charge === 0" :src="item.hover ? img_more02 : img_more01" />
              <span v-else>Payment information: 2 yuan/piece</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 底部新闻 查看更多 -->
    <div class="moreService">
      <a href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span>Learn more</span>
      </a>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header_English.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer_English.vue'
import payPage from '@/components/comForPc/payPage.vue'
import solvePage from '@/components/comForPc/English_model/E_solve.vue' // 我们提供全面的解决方案
import robotPage from '@/components/comForPc/English_model/E_robotization.vue' // 融合零信任安全网络和自动化运维
import worldPage from '@/components/comForPc/English_model/E_world.vue' // 全球覆盖网络
import servicePage from '@/components/comForPc/English_model/E_service.vue' // 我们拥有高品质的服务
import wayPage from '@/components/comForPc/English_model/E_way.vue' // 用一个更好的方式服务企业
// import start from '@/utils/canvas'
import { WOW } from 'wowjs'
export default {
  components: { Header, Sidebar, Footer, payPage, solvePage, robotPage, worldPage, servicePage, wayPage },
  data () {
    return {
      moudleArr: [], // 文章数据集合
      newsArr: [], // 新闻数据集合
      solveArr: [], // 解决方案数据集合
      viewHeight: 0, // 屏幕高度
      img_more01: require('../assets/images/img_more01.png'),
      img_more02: require('../assets/images/img_more02.png'),
      bannerArr: [], // 轮播图数据集合
      imgHeight: '', // 轮播图高度
      viewWidth: '', // 屏幕宽度
      tipsBoxWidth: '', // 计算解决方案 切换模块宽度
      swiperOptions: { // 移动轮播图配置
        autoplay: 3000,
        speed: 1000,
        loop: true,
        pagination: '.swiper-pagination'
      },
      baseImgUrl: '',
      bgUrl: '',
      bgUrl2: ''
    }
  },
  methods: {
    // 获取首页文章
    getHomeId (arr) {
      let modelArr = []
      JSON.parse(arr).forEach(item => {
        if (item.id === 1) {
          modelArr = item.articleList
        }
        if (item.id === 5) {
          item.articleList.forEach(item => {
            item.hover = false
          })
          this.newsArr = item.articleList
        }
        if (item.id === 3) {
          item.articleList.forEach(items => {
            items.tagsChecked = false
            items.path = item.path
            if (items.description && (items.description.indexOf('@') !== -1)) {
              let arr = items.description.split('@')
              items.descriptionStr = arr[0]
              arr.shift()
              items.descriptionArr = arr
            }
          })
          item.articleList[0].tagsChecked = true
          this.solveArr = item.articleList
          console.log(this.solveArr)
        }
      })
      let haveTags = false
      let tagsArr = []
      let modelArrNew = []
      modelArr.forEach(item => {
        if (item.tags && item.tags.length > 0) {
          item.tags.forEach(items => {
            if (items.name === 'homeTabs') {
              item.tagsText = 'homeTabs'
              tagsArr.push(item)
            }
            if (!haveTags) {
              item.tagsIndex = 0
              haveTags = true
            }
          })
        }
      })
      modelArr.forEach((item, index) => {
        if (item.tagsText && item.tagsText === 'homeTabs' && item.tagsIndex === 0) {
          tagsArr.forEach(items => {
            items.tagsChecked = false
          })
          tagsArr[0].tagsChecked = true
          item.tagsArr = tagsArr
        }
      })
      modelArr.forEach((item, index) => {
        if (!item.tagsText) {
          modelArrNew.push(item)
        }
        if (item.tagsText && item.tagsText === 'homeTabs' && item.tagsArr) {
          modelArrNew.push(item)
        }
      })
      this.moudleArr = modelArrNew
      this.wowInit()
    },
    // 滚动到相应位置 注册animate动画
    wowInit () {
      // wow初始化
      this.$nextTick(() => {
        const wow = new WOW({
          boxClass: 'wow', // default
          animateClass: 'animated', // default
          offset: 150, // default
          mobile: true, // default
          live: false,
          // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
          callback: function (box) {
            console.log('WOW: animating <' + box.tagName.toLowerCase() + '>')
          }
        })
        wow.init()
      })
    },
    // 解决方案 点击
    // changeTags (indexs) {
    //   this.solveArr.forEach(item => {
    //     item.tagsChecked = false
    //   })
    //   this.solveArr[indexs].tagsChecked = true
    // },
    // 解决方案 点击 了解更多
    toSolveInfo (item) {
      this.$router.push({ path: item.path, query: { id: item.categoryId, childId: item.id } })
    },
    // 点击 滚动一屏
    goDown () {
      window.scrollTo({
        top: this.viewHeight - 64,
        left: 0,
        behavior: 'smooth'
      })
    },
    // 跳转到 获取方案页面
    toPlan () {
      this.$router.push('/getPlan')
    },
    // 底部 查看更多 跳转到新闻咨询列表
    toNews () {
      this.$router.push({ path: '/news', query: { id: 5 } })
    },
    // 新闻资讯 跳转到详情页面
    getInfo (data) {
      if (data.charge === 0) {
        this.$router.push({ path: '/newsInfo', query: { id: data.id } })
      } else {
        this.$refs.pay.showDialog()
      }
    },
    // 新闻资讯 鼠标悬浮效果 移入
    hoverNews (index) {
      this.newsArr.forEach(item => {
        item.hover = false
      })
      this.newsArr[index].hover = true
    },
    // 新闻资讯 鼠标悬浮效果 移出
    outNews () {
      this.newsArr.forEach(item => {
        item.hover = false
      })
    },
    // 获取轮播图图片集合
    getBannerImg () {
      this.bannerArr = [
        {
          title: ' Innovators and leaders in next-generation network architecture and NaaS',
          subtitle: 'Provide compliant and intelligent network services to ensure the stable operation of Internet applications！',
          sliderImg: require('../assets/images/banner.jpg')
        }
      ]
    },
    // 获取banner图第一张图片的高度 适配移动端轮播图
    imgLoad () {
      if (this.bannerArr.length > 0) {
        let _self = this
        setTimeout(function () {
          _self.$nextTick(() => {
            _self.imgHeight = _self.$refs.swiperImg[0].height
          })
        }, 400)
      }
    },
    // 轮播图 跳转到
    toInfo (item) {
      return false
    },
    // 当窗口宽度发生改变
    changeViewWidth () {
      this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
      // if (this.viewWidth >= 1180) {
      //   this.tipsBoxWidth = 1180 /
      // } else {
      //   this.tipsBoxWidth = this.viewWidth / 3
      // }
    }
  },
  created () {
    this.viewHeight = document.documentElement.clientHeight || document.body.clientHeight
    this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230102/plan_1672628507168.jpg'
    this.bgUrl2 = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
    // this.getHomeId(localStorage.getItem('navList'))
    this.newsArr = [
      {
        'id': 54,
        'createTime': '2023-01-12 18:37:02',
        'updateTime': '2023-01-12 18:37:02',
        'title': 'The construction of the digital intelligent operation system in the Bank of China financial industry has developed steadily!',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230402/123_1680401795202.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'content': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>中银金融行业数字化智能运营体系建设稳健发展！</h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'contentMd': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>中银金融行业数字化智能运营体系建设稳健发展！</h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'top': 0,
        'categoryId': 5,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': this.baseImgUrl + '/u/20230128/c28e463517f656c8f73e436a2118ff34_1674871435624.jpg',
        'menuImg': '',
        'original': 1,
        'charge': 1,
        'sort': null,
        'description': 'The construction of the digital intelligent operation system in the Bank of China financial industry has developed steadily!@Top Top',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 57,
        'createTime': '2023-01-15 17:26:57',
        'updateTime': '2023-01-15 17:26:57',
        'title': 'Evolution, taking you into intelligent life',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230402/456_1680401795204.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'content': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>进化，带你走进智能生活<br></h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'contentMd': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>进化，带你走进智能生活<br></h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'top': 0,
        'categoryId': 5,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': '',
        'original': 1,
        'charge': 1,
        'sort': null,
        'description': '',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 58,
        'createTime': '2023-01-15 17:27:15',
        'updateTime': '2023-01-15 17:27:15',
        'title': 'Meg Network, Changing the Future',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230128/c28e463517f656c8f73e436a2118ff34_1674871318446.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'content': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>迈格网络，改变未来</h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'contentMd': '<p><style>\r\n\t@media only screen and (min-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 64px;\r\n\t\t\tmax-width: 1180px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 149px;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 30px;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 42px;\r\n\t\t\tmargin-bottom: 27px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tdisplay: block;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 25px;\r\n\t\t\tmargin-bottom: 70px;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 810px;\r\n\t\t\tmax-width: 810px;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-bottom: 67px;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 25px;\r\n\t\t}\r\n\r\n\t}\r\n\r\n\t@media only screen and (max-width: 1024px) {\r\n\t\t.inner {\r\n\t\t\tbackground: #fff;\r\n\t\t\tpadding-top: 2.75rem;\r\n\t\t\twidth: 93%;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tpadding-bottom: 1.25rem;\r\n\t\t}\r\n\r\n\t\t.inner h4 {\r\n\t\t\tfont-size: 1.0625rem;\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: #353535;\r\n\t\t\tline-height: 1.5rem;\r\n\t\t\tpadding: 1rem 0;\r\n\t\t}\r\n\r\n\t\t.inner span {\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #6F788C;\r\n\t\t\tline-height: 1.125rem;\r\n\t\t}\r\n\r\n\t\t.inner div {\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin: 1.25rem 0;\r\n\t\t}\r\n\r\n\t\t.inner div img {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.inner p {\r\n\t\t\tfont-size: .875rem;\r\n\t\t\tfont-weight: 300;\r\n\t\t\tcolor: #4C5461;\r\n\t\t\tline-height: 1.375rem;\r\n\t\t}\r\n\t}\r\n</style>\r\n</p><div class="inner">\r\n\t<h4>迈格网络，改变未来</h4>\r\n\t<span>2022/11/23 12:37:11</span>\r\n\t<div>\r\n\t\t<img src="http://47.92.227.246:8081/u/20230119/photo-1523006480666-4debbb34a28d备份_1674115245566.png">\r\n\t</div>\r\n\t<p>\r\n\t\t1月6日的上午，全球新能源巨头特斯拉高调宣布，其在中国市场出售的国产车启动全线降价，据特斯拉官网显示，特斯拉国产车型售价已经更新，其中Model 3起售价22.99万元，Model Y起售价25.99万元。\r\n\t\t在国补刚刚退出历史舞台，国产新能源抱团涨价的背景下，特斯拉在此敏感时刻抛出王炸，必然瞬间引爆市场。毕竟此次降价，不管是特斯拉谋划已久还是临时起意，可以肯定的是，面对众多国产新能源品牌全力追赶的特斯拉，要在国内市场动真格的了。\r\n\t\t01.\r\n\t\t特斯拉背刺集体涨价的国产新能源\r\n\t\t特斯拉降价的消息，不仅对于市场是颗重磅炸弹，甚至自己的员工事前也没有消息。\r\n\t\t“我们也是今早才知道降价的，上午来店里订车的客户明显增加了很多。”据媒体援引特斯拉成都某门店销售人员的表述，可以猜测到特斯拉在终端门店的降价通知一直没有走漏风声，因此在公布降价消息后，特斯拉门店马上出现人头攒动的景象，并直接拉动订单提升。\r\n\t\t那么本次特斯拉降价诚意到底有多大？不妨来看看特斯拉中国官网的最新价格：Model 3起售价22.99万元，对比之前价格下降3.6万元；Model Y起售价25.99万元，下降2.9万元。\r\n\t\t而未上市的车型也涵盖在本次降价当中，其中Model S双电机全轮驱动版78.99万元起，Model S Plaid三电机全轮驱动版100.99万元起。Model X双电机全轮驱动版87.99万元起，Model X Plaid\r\n\t\t三电机全轮驱动版103.99万元起，根据官方消息预计，以上车型即将在上半年与消费者见面。\r\n\t\t从上述售价调整可以看出，特斯拉在国补刚刚结束的时点推出降价措施，可谓诚意满满，而这种诚意，更来自于国产新能源集体涨价的对比之下。\r\n\t\t先看国产新能源龙头比亚迪，2022年12月31日，比亚迪汽车官方微博发布公告，宣布比亚迪汽车决定自2023年1月1日起，对相关车型官方指导价进行正式调整，上调幅度为2000-6000元不等，详情可咨询当地经销商。新价格将于1月1日零时起生效，在此之前支付定金签约的客户不受此次调价影响。\r\n\t\t再看性价比路线的代表品牌奇瑞，其在2023年1月发布消息，在国补退坡后调整了小蚂蚁和无界Pro两款车型官方指导价，其中涉及小蚂蚁甜粉款、小蚂蚁魅、小蚂蚁30万蚁粉款和无界Pro的高配车型，涨价幅度3000-9000元。此次调价后，小蚂蚁车型售价为7.99-10.3万元；无界Pro车型售价为8.99-11.59万元。\r\n\t\t而背靠国企的上汽荣威也同样加入了涨价的队伍，其官方宣布，自2023年1月1日期起对旗下部分新能源车型的官方指导价进行上调，上调幅度为0.5-0.8万元。其中，上汽荣威旗下全新第三代荣威超混eRX5的官方指导价上调5000元；荣威Ei5与荣威i6\r\n\t\tMAX EV车型的官方指导价上调6000元；CLEVER科莱威的官方指导价上调8000元。\r\n\t\t也就是说，随着国补正式退坡，国产新能源车企，无论是民资还是国有品牌，抱团在这个敏感的时点集体涨价消解成本压力成为大多数车企的一个市场选择，虽然在市场逻辑下，政策端、产业端都能理解涨价的动机，但在消费者一侧，集体涨价行为无疑给人了一种不负责任的转嫁成本的印象。\r\n\t\t而特斯拉在这个关键节点选择与国产新能源车企站在了对立面，到底是哪里来的底气？\r\n\t\t02.\r\n\t\t高调打响价格战\r\n\t\t马斯克葫芦里卖的什么药\r\n\t\t有分析认为，特斯拉本次价格宣战，很可能与其产品的市场需求尚未完全打开有关系。\r\n\t\t据官方数据显示，特斯拉在2022年总共交付131万辆新车，产量约为136.9万辆，同比增长40%，其中，特斯拉Model 3和Model Y两款车型在2022全年合计交付了124.7万辆。\r\n\t\t而在国内市场，据乘联会发布中国市场预估销量，2022年，特斯拉上海超级工厂全年交付超71万辆，同比增长48%，而目前该工厂的产能，已经超过75辆每年。\r\n\t\t也就是说，特斯拉现在的情况是产的多，卖的少。那么卖的少了多少？回顾年初特斯拉年交付150万辆的豪言壮语，2022年实际交付量距离目标其实整整差了18万辆。\r\n\t\t有相关人士表示，2022年二期生产线投产以后，特斯拉的产能大幅增加，但销量增速放缓，产线利用率反而降低了。\r\n\t\t销量不及预期之下，更令特斯拉不安，是股价的持续走低。\r\n\t\t本周四特斯拉收跌2.9%，报110.34美元，在整个2022年，特斯拉市值蒸发70%。\r\n\t\t令人悲伤的股价表现，加上1月3日公布的年度交付数据，让华尔街各大机构集体下调对特斯拉的预期。\r\n\t\t华尔街机构Cowen将特斯拉的目标价从205美元大幅下调至122美元，降幅达40.5%。花旗分析师则表示，在特斯拉正在大量增加产能之际，交付数据不及预期，可能会加剧人们对其未来需求的担忧，对特斯拉的评级为中性。\r\n\t\tBernstein也下调了对特斯拉的评级和目标价，并认为2023年度的（交付）数据可能会“出现重大调整”：“我们还担心，在利率上升以及消费者支出放缓之际，市场可能面临更大压力，继续对特斯拉等估值较高的股票造成更为严重的影响。\r\n\t\t很显然，马斯克已经意识到特斯拉正处于巨大的怀疑声中，而打消这种怀疑的，自然是提振销量。\r\n\t\t这可能也就解释了为何特斯拉在毫无征兆的情况下，突然高调宣布全线降价，毕竟授意冲刺业绩的掌门人，也才刚刚下定以价换量的巨大决心。\r\n\t\t03.\r\n\t\t售价原地变向\r\n\t\t新车主抱团要找特斯拉算账\r\n\t\t实际上，过去一年里，特斯拉售价可谓变化莫测。据媒体统计，仅在2022年3月，特斯拉就连续三次调整价格：2022年3月10日，Model Y长续航版涨价1万，报价35.79万元，Model\r\n\t\tY高性能版涨价1万，报价39.79万元\r\n\t\t2022年3月15日，Model Y长续航版涨价1.8万，报价37.59万元，Model Y高性能版涨价2万，报价41.79万元\r\n\t\t2022年3月17日，Model Y后轮驱动版涨价1.5万，报价31.69万元\r\n\t\t一路上涨是特斯拉2022上半年的主题，但谁能想到，下半年特斯拉就来了一个原地变向。\r\n\t\t据媒体报道，特斯拉从去年9月份就通过各种促销手段，开始拉低车价。在这其中，特斯拉先是对于自9月16日到9月30日完成提车的车主提供8000元保险补贴，保险补贴可直接用于减免车价。然后在去年10月24日，宣布国产车型全系下调售价，下调幅度在1.4万~3.7万元。此后，\r\n\t\t而在国补即将取消的当口，特斯拉也推出新年限时福利进行市场占领，其内容包括即日至2月28日期间，完成交付的Model 3和Model\r\n\t\tY的新车订单，可享受6000元限时交付激励方案；若通过特斯拉合作保险机构购买相应车险，还可享受4000元保险补贴。\r\n\t\t就在新年限时活动刚刚开始不久，特斯拉又放出“王炸”，全线下调车价，可见其已经彻底抛弃了涨价路线，决定拥抱潜在的客群。\r\n\t\t但是，此举在赢得新用户的同时，也招来大量老客户的投诉。其中部分去年12月刚刚入手特斯拉的车主，就成为了名副其实的“韭菜”群体。在社交媒体上，甚至有车主宣称一共提车五天，居然每天平均亏损高达一万。\r\n\t\t在毫无预兆的降价之下，刚刚入手特斯拉的车主急需明确是否会补偿差价。而对于这一点，据媒体采访特斯拉客服，结果并不乐观。\r\n\t\t据客服解释，若车主已下订单但未提车，则可以在当前官网价格和订单价之间二选一，但会和此前的补贴政策冲突。若车主在降价前已提到车，则无法享受上述政策，且有相关补偿政策的可能性较低。\r\n\t\t在这种情况下，自然引起了新车主们的极大不满，这一群体很大程度上都是因为国补退场而跑步购入特斯拉，但如今，却要面临着瞬时亏损的窘境，可以想见他们下一步对特斯拉抱团要说法的行动。\r\n\t\t而对于其他潜在客群来说，一再降价的举动，正是特斯拉和消费者的又一次博弈，是否还会继续下降，也成为目前该客群持续观望的原因。\r\n\t\t在这种情况下，特斯拉在引爆新能源市场之后，恐怕会迎来更加错综复杂的局面了。\r\n\t\t参考资料：\r\n\t\t1、《特斯拉挥出降价大刀 新能源车打响价格战？》，封面财经\r\n\t\t2、《特斯拉车价降至史上最低 消费者心情有点复杂》，天目新闻\r\n\t\t3、《国产Model 3降至史上最低！中国、日本同日大促，“杀疯了”的特斯拉能顺利拉动需求吗？》，每日产经新闻\r\n\t</p>\r\n</div>\r\n<p></p>',
        'top': 0,
        'categoryId': 5,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': '',
        'original': 1,
        'charge': 1,
        'sort': null,
        'description': 'News Consultation Module 3@123',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [],
        'bizCategory': null,
        'path': null
      }
    ]
    this.getBannerImg()
  },
  mounted () {
    // canvas初始化
    // start()
    window.onresize = () => {
      this.imgLoad()
      this.changeViewWidth()
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>
<style lang="less" scoped>
.swiper-image {
  width: 100%;
  height: 270px;
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  .home {
    padding-top: 2.75rem;
    overflow-x: hidden;
  }
  // 按钮样式
  .comButton {
    padding: 0.9375rem 2.25rem;
    color: #fff;
    border-radius: 1.75rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    height: 3.125rem;
    font-size: 0.7rem;
  }
  .moreService {
    text-align: center;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .el-carousel_pc {
    display: none;
  }
  // 轮播图样式
  .currencyTitle {
    display: flex;
    justify-content: center;
    margin: 2rem 0 2rem 0;
    img {
      width: 1.75rem;
      height: 1.55rem;
    }
    h3 {
      color: #08142a;
      font-size: 1rem;
      font-weight: bold;
      margin-left: 1rem;
    }
  }
  .styleBox_05 {
    width: 100%;
    .tipsBox {
      box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
      // height: 6.25rem;
      display: flex;
      position: relative;
      z-index: 9;
      overflow-x: scroll;
      width: 100%;
      overflow-x: scroll;
      li {
        width: 33.3%;
        font-size: 0.875rem;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;
        flex: 1;
        padding: 0.75rem 1.56rem;
        line-height: 1.6rem;
        .tipNum {
          color: #90bff7;
          font-size: 1rem;
        }
      }
      .checked {
        background-image: linear-gradient(
          228deg,
          rgba(62, 227, 255, 1),
          rgba(46, 158, 253, 1) 62%,
          rgba(24, 106, 232, 1)
        );
        color: #fff;
      }
    }
    .numberTips {
      display: flex;
      justify-content: center;
      span {
        width: 1.5rem;
        height: 0.25rem;
        border-radius: 0.125rem;
        background: #d6dfed;
        margin-right: 0.5rem;
        margin-top: 1.43rem;
      }
      span:last-child {
        margin-right: 0;
      }
      .spanCheck {
        background: #428bf8;
      }
    }
  }
  .newsBg {
    background: url('../assets/images/img_news.jpg') no-repeat;
    padding-top: 9.5rem;
    background-size: 100% 91%;
    .el-carousel__item {
      box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
      border-radius: 0.5rem;
      overflow: hidden;
    }
  }
  /deep/ .newBanner {
    background: #fff;
    height: 100%;
    img {
      transform: none;
      left: 0;
      top: 0;
      position: relative;
      min-width: auto;
    }
    .bannerImg {
      width: 100%;
    }
    h4 {
      padding: 1.25rem 1.25rem 0;
      font-size: 1rem;
      font-weight: 600;
      color: #353535;
      display: flex;
      align-items: center;
      justify-content: center;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    p {
      padding: 0 1.25rem 0;
      font-size: 0.875rem;
      font-weight: 300;
      color: #4c5461;
    }
    .newFooter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1.1875rem 0;
      position: absolute;
      bottom: 1rem;
      width: 100%;
      img {
        width: 1.175rem;
        float: right;
      }
      span {
        font-size: 0.8125rem;
        font-weight: 300;
        color: #6f788c;
      }
    }
  }
  .styleBox_06 {
    display: none;
  }
  .swiper-container {
    position: relative;
  }
  .swiper-pagination {
    width: 100%;
  }
  .swiper-pagination-bullet {
    margin: 0 0.5rem;
  }
  .swiper-slide {
    position: relative;
    img {
      width: 100%;
      width: 100%;
    }
    .blockText {
      padding-top: 3rem;
      position: absolute;
      z-index: 9;
      width: 100%;
      text-align: center;
      height: 100%;
      z-index: 3;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      h5 {
        font-size: 0.9375rem;
        color: #fff;
        max-width: 80%;
        font-size: 0.9375rem;
        font-weight: normal;
        color: #ffffff;
        letter-spacing: 0.125rem;
        pre{
          white-space: pre-wrap;
          word-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          text-align: center;
        }
      }
      h4 {
        font-size: 1.125rem;
        font-weight: bold;
        color: #ffffff;
        max-width: 80%;
        letter-spacing: 0.125rem;
        text-shadow: 0px 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
        margin-bottom: 1.6875rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-align: center;
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .swiper-container {
    display: none;
  }
  .newsBg {
    display: none;
  }
  .home {
    width: 100%;
    background: #fff;
    // 按钮样式
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      height: 50px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    .el-carousel_mobile {
      display: none;
    }
    // 轮播图样式
    .el-carousel {
      position: relative;
      overflow: hidden;
      img {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        min-width: 100%;
        min-height: 100vh;
        transform: translate(-50%, -50%);
      }
      .blockText {
        position: relative;
        z-index: 9;
        height: 100vh;
        z-index: 3;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        h5 {
          font-size: 30px;
          color: #fff;
          margin-bottom: 100px;
          max-width: 1180px;
          font-weight: 100;
          text-align: center;
          pre{
            white-space: pre-wrap;
            word-wrap: break-word;
          }
        }
        h4 {
          max-width: 1180px;
          font-size: 52px;
          color: #fff;
          margin-bottom: 48px;
          letter-spacing: 5px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
          text-align: center;
        }
      }
    }
    // 通用标题
    .currencyTitle {
      display: flex;
      justify-content: center;
      margin: 50px 0 85px 0;
      img {
        width: 69px;
        height: 54px;
      }
      h3 {
        color: #08142a;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-left: 22px;
      }
    }
    .innerBox {
      width: 100%;
      overflow: hidden;
    }
    .styleBox_05 {
      width: 100%;
      .tipsBoxWall {
        box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
        height: 90px;
        position: relative;
        z-index: 9;
      }
      .tipsBox {
        display: flex;
        max-width: 1180px;
        overflow-x: scroll;
        margin: 0 auto;
        outline: none;
        height: 100%;
        scrollbar-color: rgb(205, 205, 205);
        scrollbar-width: thin;
        -ms-overflow-style: none;
        li {
          padding: 19px 16px;
          font-size: 19px;
          font-weight: bold;
          display: flex;
          align-items: center;
          cursor: pointer;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
          .tipNum {
            color: #90bff7;
            font-size: 30px;
            margin-right: 12px;
          }
        }
        .checked {
          background-image: linear-gradient(
            228deg,
            rgba(62, 227, 255, 1),
            rgba(46, 158, 253, 1) 62%,
            rgba(24, 106, 232, 1)
          );
          color: #fff;
        }
      }
      .tipsBox::-webkit-scrollbar {
        width: 20px;
        height: 6px;
      }
      .tipsBox::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: rgb(205, 205, 205);
      }
      .tipsBox::-webkit-scrollbar-button {
        width: 0;
        border-radius: 50%;
        background: black;
      }
      .tipsBox::-webkit-scrollbar-track {
        // box-shadow: inset 0 0 2px #333;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0);
      }
      .tipsBox::-webkit-scrollbar-corner {
        background: springgreen;
      }
    }
    .styleBox_07 {
      width: 100%;
      height: 320px;
      background: url('http://47.92.227.246:8081/u/20230101/img_gg_1672576300037.jpg')
        no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .styleBox_07 p {
      font-size: 32px;
      font-weight: 600;
      color: #08142a;
      margin-bottom: 44px;
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    .styleBox_06 {
      position: relative;
      padding-top: 154px;
      padding-bottom: 50px;
    }
    .styleBox_06 ul {
      position: relative;
      z-index: 9;
      max-width: 1180px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .styleBox_06 ul li {
      width: 32%;
      box-shadow: 0px 2px 5px 0px rgba(204, 204, 204, 0.5);
      border-radius: 12px;
      overflow: hidden;
      transition: all 0.4s;
      -moz-transition: all 0.4s;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      border: 4px solid rgba(204, 204, 204, 0);
      box-sizing: border-box;
      background: #fff;
    }
    .styleBox_06 ul li:hover {
      transform: scale(1.05) translateY(-24px);
      border: 4px solid #428bf8;
      cursor: pointer;
    }
    .styleBox_06 ul li img {
      width: 100%;
    }
    .styleBox_06 ul li h4 {
      padding: 23px 30px 16px;
      font-size: 20px;
      font-weight: 600;
      color: #4c5461;
      height: 78px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .styleBox_06 ul li p {
      height: 64px;
      font-size: 16px;
      font-weight: 300;
      color: #4c5461;
      padding: 0 30px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      margin-bottom: 18px;
    }
    .styleBox_06 ul li div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px 35px;
    }
    .styleBox_06 ul li div span {
      font-size: 16px;
      font-weight: 300;
      color: #6f788c;
    }
    .styleBox_06 ul li div img {
      width: 36px;
      height: 36px;
    }
    .styleBox_06 .news_bg {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      min-width: 100%;
      min-height: 345px;
      max-height: 345px;
    }
    .moreService {
      padding: 50px 0 91px;
      display: flex;
      justify-content: center;
    }
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
  }
}
</style>
<style>
@media only screen and (min-width: 1024px) {
  .tipsInner {
    background-repeat: no-repeat;
    background-size: cover;
    height: 600px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tipsInner .tipsInnerWidth {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg {
    margin-right: 95px;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg img {
    width: 530px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText {
    text-align: left;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul {
    display: flex;
    flex-wrap: wrap;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li {
    width: 40%;
    position: relative;
    font-size: 16px;
    font-weight: 300;
    color: #4c5461;
    margin-bottom: 20px;
    margin-left: 22px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: linear-gradient(138deg, #89bcff 0%, #5e70ff 100%);
    border-radius: 5px;
    left: -22px;
    top: 5px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText h4 {
    font-size: 22px;
    font-weight: bold;
    color: #353535;
    line-height: 30px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText .icon_01 {
    width: 36px;
    height: 10px;
    border-radius: 10px;
    background-image: linear-gradient(228deg, #5e70ff, #89bcff 62%);
    margin: 29px 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText p {
    font-size: 16px;
    color: #353535;
    line-height: 30px;
    font-weight: 300;
    margin-bottom: 30px;
    text-align: left;
  }
  .tipsInner .tipsInnerWidth .tipInnerText .btnBox {
    text-align: right;
  }
}

@media only screen and (max-width: 1024px) {
  .tipsInner {
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tipsInner .tipsInnerWidth {
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 1.875rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg {
    margin-right: 95px;
    margin: 0 auto;
    width: 80%;
    margin-bottom: 1rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg img {
    width: 100%;
  }

  .tipsInner .tipsInnerWidth .tipInnerText {
    text-align: left;
    width: 80%;
    margin: 0 auto;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li {
    width: 50%;
    position: relative;
    font-size: 0.875rem;
    font-weight: 300;
    color: #4c5461;
    margin-bottom: 20px;
    text-indent: 1.56rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: linear-gradient(138deg, #89bcff 0%, #5e70ff 100%);
    border-radius: 0.5rem;
    left: 0.1rem;
    top: 0.2rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerText h4 {
    font-size: 1.06rem;
    font-weight: bold;
    color: #353535;
    line-height: 30px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText .icon_01 {
    width: 36px;
    height: 10px;
    border-radius: 10px;
    background-image: linear-gradient(228deg, #5e70ff, #89bcff 62%);
    margin: 29px 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText p {
    font-size: 0.875rem;
    color: #353535;
    line-height: 30px;
    font-weight: 300;
    margin-bottom: 30px;
    text-align: left;
  }
  .tipsInner .tipsInnerWidth .tipInnerText .btnBox {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/English-page.vue